import { Injectable } from '@angular/core';
import { CoordinatesDto } from '../types/dtos/device.dto';

@Injectable({
  providedIn: 'root',
})
export class CoordsService {
  private readonly _baseUrl: string = 'https://nominatim.openstreetmap.org';

  /**
   * Retrieves the street name corresponding to the given geographical coordinates.
   *
   * @param coords An object containing latitude and longitude properties.
   * @return A promise that resolves to the street name as a string. Returns an empty string if no data is available.
   */
  public async streetNameFromCoords(coords: CoordinatesDto): Promise<string> {
    // https://nominatim.openstreetmap.org/ui/reverse.html?lat=49.48700000394427&lon=6.352795958518983&zoom=18

    const url = `${this._baseUrl}/reverse?format=jsonv2&lat=${coords.latitude}&lon=${coords.longitude}&zoom=18&accept-language=lu`;
    const response: Response = await fetch(url);
    const data: any = await response.json();
    if (!data) {
      return '';
    }
    return data.display_name;
  }
}
